import React, { useState } from 'react';
import { Modal, Form, Button, Image } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Editor from "../../combination/editor";
import timestamp from '../../../assecs/plugin/timestamp'; 

/* import fetch function */
import { EditMessage } from "../../../services/message";
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const ViewMessage = () => {
    const { data } = useSelector(state => state.model);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState(data);
    const [messageImage, setImage] = useState(data.image);
    
    const createFormData = () => {
        const formData = new FormData();

        formData.append('msgName', source.msgName);
        formData.append('type', source.type);
        formData.append('target', source.target);
        formData.append('sendDate', source.sendDate);
        formData.append('descriptionEnglish', source.descriptionEnglish);
        if (source.descriptionChinese && source.descriptionChinese !== "<p><br></p>") {
            formData.append('descriptionChinese', source.descriptionChinese);
        }
        if (source.descriptionGerman && source.descriptionChinese !== "<p><br></p>") {
            formData.append('descriptionGerman', source.descriptionGerman);
        }
        if (source.descriptionSpanish && source.descriptionChinese !== "<p><br></p>") {
            formData.append('descriptionSpanish', source.descriptionSpanish);
        }
        if (source.descriptionFrench && source.descriptionChinese !== "<p><br></p>") {
            formData.append('descriptionFrench', source.descriptionFrench);
        }
        if (source.image instanceof File) {
            formData.append('imageChanged', true);
            formData.append('image', source.image);
        } else if(!source.image){
            formData.append('imageChanged', true);
        } else{
            formData.append('imageChanged', false);
        }
         return formData;
    };

    const cancelHandler = () => 
        dispatch(resetModel()
    );

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {

            const resource = createFormData();

            EditMessage({ id: data.msgId, source: resource }).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['msgName', 'type', 'target', 'sendDate','descriptionEnglish'];
        const _errors = {};
        
        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    const changHandler = ({target, target: { name, value, files }}) => {
        const _source = Object.assign({}, source);
        
        if (name === 'fcmType')
            delete error.type;
        else
            delete error[name];

        if (value.length) {
            if (name === 'fcmType')
                _source.type = value;
            else
                _source[name] = value;
        }

        if (files) {
            _source[name] = files[0];
            setImage(URL.createObjectURL(files[0]));
            target.value = null;
            console.log(_source)
        }

        setError(error);
        setSource(_source);
    };

    const clearImage = () => {
        const _source = Object.assign({}, source);

        delete _source.image;
        
        setImage(null);
        setSource(_source);
    };

    const pickerHandler = dates => {
        let _source = Object.assign({}, source);
        if (!dates){
            delete _source.sendDate;
        } else {
            const sendDate = `${dates.$y}-${dates.$M + 1}-${dates.$D} ${dates.$H}:${dates.$m}:${dates.$s}`;
            let _sendDate =new Date(sendDate);
            if ((_sendDate.getTime() < new Date().getTime())){
               delete _source.sendDate;
             }

            _source.sendDate = _sendDate.getTime();
            delete error['sendDate'];
            
        }
        setError(error);
        setSource(_source);
    };

    const renderFileExtensionMessage = () => {
        if (!messageImage) {
            return (
                    <div className='label small'>Please select a file with a .jpeg or .png extension.</div>
            );
        }
        return null;
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>View data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Message Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='msgName' defaultValue={ data.msgName } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Send Date</div>
                        <span className='semicolon'>：</span>
                        <DatePicker 
                        name='sendDate' 
                        className='form-picker' 
                        showTime 
                        status={error['sendDate'] && 'error'} 
                        onChange={pickerHandler} 
                        placeholder='Please pick the future time'
                        defaultValue={data.sendDate ? dayjs(data.sendDate) : null}
                        value={source.sendDate ? dayjs(source.sendDate) : null}
                        />
                    </div>
                    <div className="form-item">
                        <div className='label'>Message Type</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='type' defaultValue={ data.type } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Send Target</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='target' defaultValue={ data.target } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Status</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='status' defaultValue={ data.status } disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Image</div>
                        <span className='semicolon'>：</span>
                        <div className="button-group">
                            <label className='btn' is-required={ `${error.newMonsterPhoto}` }>
                                <span>Choose File</span>
                                <input type="file" name='image' accept="image/png, image/jpeg" hidden onChange={ changHandler } />
                            </label> 
                            <Button type="button" onClick={ clearImage }>Unchoose File</Button>
                            {renderFileExtensionMessage()}
                        </div>
                    </div>
                    <div className="form-item form-image-item">
                        { messageImage && <Image src={ messageImage } /> }
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } readOnly={ false }/>
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ViewMessage;